export default "__VITE_ASSET__DQfT1Rez__"